import { render, staticRenderFns } from "./TenderReports.vue?vue&type=template&id=74826296&scoped=true"
import script from "./TenderReports.vue?vue&type=script&lang=js"
export * from "./TenderReports.vue?vue&type=script&lang=js"
import style0 from "./TenderReports.vue?vue&type=style&index=0&id=74826296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74826296",
  null
  
)

export default component.exports